import React, {
  useEffect,
  useMemo,
  useState,
} from "react";
import { format, parseISO } from 'date-fns';
import pt from 'date-fns/locale/pt';

import DataTable from "../../components/DataTable";
import * as contratoService from "../../services/contrato.service";
import { IContrato,IContratoItem } from "../../common/interfaces/contrato.interfaces";
import DataNotFound from "../../components/DataNotFound";
import { Col, Row } from "react-bootstrap";

const Contrato: React.FC = () => {

  //Fields Typed
  const DataTableTS: any = DataTable;

  //States
  const [tableData, setTableData] = useState<IContrato[]>([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [reloadGrid, setReloadGrid] = useState(false);

  //Effects
  useEffect(() => {
    (async () => {
      try {
        setTableLoading(true);

        const response = await contratoService.obterContratos();
        setTableData(response);
      } catch (error) {
      } finally {
        setTableLoading(false);
      }
    })();
  }, [reloadGrid]);

  const columns = useMemo(
    () => [
      {
        Header: "Produto",
        accessor: "produto",
        display: "align-middle",
      },
      {
        Header: "Renovação",
        accessor: "validade",
        display: "align-middle",
        Cell: ({ row: { original } }: { row: { original: IContratoItem } }) => (
          <span>{format(parseISO(original.inicio.toString()), 'dd/MM/yyyy', { locale: pt })} - {format(parseISO(original.fim.toString()), 'dd/MM/yyyy', { locale: pt })}</span>
        )
      },
      {
        Header: "Valor",
        accessor: "valor",
        display: "align-middle",
        Cell: ({ row: { original } }: { row: { original: IContratoItem } }) => (
          <span>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(original.valor)}</span>
        )
      },
    ],
    []
  );

  return (
    <>
      <div className="content py-3">
        <div className="container-xl mb-3">
          <div className="page-header">
            <div className="row">
            <h1>Contratos</h1>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <div className={'dimmer' + (tableLoading ? ' active' : '')}>
                    <div className="loader"></div>
                    <div className={"dimmer-content" + (tableLoading ? ' medium-box-loader' : '')} >
                      {tableData && (
                        tableData.map(c => (
                          <div className="card mb-4">
                            <div className="card-header">
                              <Row>
                                <div className="col-12">
                                  <label className="form-label mb-0">Código Contrato</label>
                                  <div className="form-control-plaintext">{c.codigoContrato}</div>
                                </div>
                              </Row>
                            </div>
                            <div className="card-body">
                              <Row>
                                <h2 className="mt-2 mb-3">
                                  Contato Comercial
                                </h2>
                                <Col xl={4} lg={4} md={6}>
                                  <label className="form-label mb-0">Nome</label>
                                  <div className="form-control-plaintext">{c.gerenteContaNome}</div>
                                </Col>
                                <Col xl={4} lg={4} md={6}>
                                  <label className="form-label mb-0">E-mail</label>
                                  <div className="form-control-plaintext">{c.gerenteContaContatoEmail}</div>
                                </Col>
                                <Col xl={4} lg={4} md={6}>
                                  <label className="form-label mb-0">Telefone</label>
                                  <div className="form-control-plaintext">{c.gerenteContaTelefone}</div>
                                </Col>
                                <h2 className="mt-4 mb-3">
                                  Produtos Contratados
                                </h2>
                                <div>
                                  <DataTableTS
                                    columns={columns}
                                    data={c.items}
                                    bordered={false}
                                    initialState={{
                                      sortBy: [
                                        {
                                          id: "codigoContrato",
                                          desc: true,
                                        },
                                      ],
                                    }}
                                  />
                                </div>
                              </Row>
                            </div>
                          </div>
                        ))
                        
                      )}
                      <DataNotFound
                        visible={
                          tableLoading === false ? tableData?.length === 0 : false
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contrato;
